// src/data/planosGratisData.js

export const planosGratisData = [
    //datos reales
    {
        "identity": "pl-0031",
        "name": "Edificio Multifamiliar: Amplitud Vertical y Diseño Funcional",
        "category": "Departamento",
        "area": 131,
        "rooms": 6,
        "floors": 4,
        "front": 7.5,
        "depth": 17,
        "dimencion": "7x17",
        "price": 20,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 30,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777931125/gqb8brueofffkjjhyoml.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777931146/uoaqlkp0xecuwqjxga3q.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777931230/zshvbifglsasn1jdt9sk.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Ambientes Saludables, Alturas Confortables",
        "description": "Documentación técnica que detalla la volumetría de un edificio residencial de cuatro niveles, donde se aprecia un diseño de planta típica desde el segundo hasta el cuarto piso. El Corte A-A permite observar la disposición de los vanos y la altura libre de cada departamento, mientras que el Corte B-B revela el diseño del núcleo de escaleras que conecta fluidamente todos los niveles hasta la azotea. La Elevación Principal muestra una fachada moderna con amplias ventanas y mamparas que garantizan una óptima iluminación natural y ventilación para cada unidad habitacional. El proyecto incluye una azotea funcional, diseñada para albergar áreas de servicio o recreación, protegida por parapetos que mantienen la estética del conjunto.",
        "masVendidos": false,
        "level": 1,
        "style": "Moderno",
        "cantidLaminas": 5,
        "driveId": "https://drive.google.com/file/d/1Ti2amIhfPwk418TEDkjN-AqKhtNbdi5T/view?usp=drive_link",
        "id": 22
    },
    {
        "identity": "pl-0041",
        "name": "Lujo y Recreación: Un Oasis Urbano en Casa",
        "category": "Hotel",
        "area": 680,
        "rooms": 12,
        "floors": 5,
        "front": 18,
        "depth": 38,
        "dimencion": "18x38",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777935757/vskb6cvq276nt2zfoywe.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777935776/dxg0yhylb91pjgnx2hpd.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777935784/fsxnzjliorne38hqdhso.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Zona de Lounge y Piscina, Distribución Inteligente",
        "description": "El proyecto se define por su versatilidad y lujo funcional. El nivel de Sótano está diseñado para una gestión vehicular impecable, ofreciendo múltiples plazas de estacionamiento numeradas y un núcleo de acceso seguro con escaleras y ascensor. El Primer Nivel se transforma en el corazón social de la vivienda, destacando una espectacular piscina circular integrada en un patio posterior con terraza, ideal para el entretenimiento. Los niveles superiores, del 2do al 4to Nivel, organizan áreas residenciales privadas que mantienen la fluidez del diseño y aseguran vistas privilegiadas hacia los espacios abiertos del complejo.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 4,
        "driveId": "https://drive.google.com/file/d/1UXytzP3Ke_SRTI9P0lmkGhlVz-CG2GDo/view?usp=drive_link",
        "id": 32
    },
    {
        "identity": "pl-0045",
        "name": "Edificio Multifamiliar Estrecho",
        "category": "Departamento",
        "area": 143,
        "rooms": 6,
        "floors": 4,
        "front": 6.5,
        "depth": 22,
        "dimencion": "6.5x22",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 45,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777936920/uplpylgdyqqbx24qd59l.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777936936/ugciik2brhzydrhbkrkl.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777936952/ujr9dvnp4nqhlnkxlcjr.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Distribución de Tres Dormitorios, Zona Social Integrada",
        "description": "El proyecto se desarrolla en tres niveles principales que optimizan cada metro cuadrado del terreno. La 1ra Planta Distribución combina un ingreso vehicular con estacionamiento frontal, una tienda comercial amplia y una zona de servicios posterior que incluye un patio de máquinas. La 2da y 3ra Planta Distribución están dedicadas íntegramente a la vivienda, configurando departamentos que se extienden a lo largo del lote, conectados por una galería de circulación lateral y una escalera de acceso independiente desde el primer nivel.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 5,
        "driveId": "https://drive.google.com/file/d/1xHrbe9t8HPmQjb1ohOsm-zFyAT4Bzn2f/view?usp=drive_link",
        "id": 36
    },
    {
        "identity": "pl-0053",
        "name": "Proyecto de Uso Mixto: Comercio y Vivienda Multifamiliar",
        "category": "Casa",
        "area": 108,
        "rooms": 4,
        "floors": 3,
        "front": 6,
        "depth": 18,
        "dimencion": "6x18",
        "price": 40,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 50,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777947977/m1srk8mnvzrymhkhgn4q.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777947997/afkxty2tf4stj6pnafnn.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777948003/d6suj7dfaihc9etkh0uk.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777948011/x80afwyanwecq6d9lvxa.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Edificio de Uso Mixto, Zona Residencial Privada",
        "description": "La edificación se distribuye para separar claramente las actividades económicas de la vida privada. El 1er Piso cuenta con un Local Comercial frontal, depósitos y un patio posterior. El 2do Piso funciona como el núcleo social y familiar, albergando la sala, comedor, cocina y el Dormitorio-01. El 3er Piso se dedica exclusivamente al descanso con los Dormitorios 03, 04 y 05, además de una sala de estar. El proyecto culmina en la Azotea, que integra el área de lavandería, y una Planta de Techo con zona de tendal.",
        "masVendidos": true,
        "level": 3,
        "style": "Minimalista",
        "cantidLaminas": 15,
        "driveId": "https://drive.google.com/file/d/1kUX5n2Hm2DjdT8ZSJixpzcFwH4p7VOfv/view?usp=drive_link",
        "id": 44
    },
    {
        "identity": "pl-0052",
        "name": "Unifamiliar con Áreas Recreativas",
        "category": "Departamento",
        "area": 270,
        "rooms": 6,
        "floors": 3,
        "front": 9,
        "depth": 30,
        "dimencion": "9x30",
        "price": 30,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Inst. Eléctricas",
            "Estructuras",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777947626/edmzkybaawl9hqmowx5v.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777947638/xnqs19w2reqwysu72emd.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777947645/rypi89jdqvo1xvppszcn.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777947654/cju62xfpzinssmjfighj.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Espacios de Entretenimiento Intimo",
        "description": "La Distribución 1° Piso se organiza para separar las actividades de servicio y trabajo de las de descanso y ocio. Al frente se ubica un Car-Port con capacidad para dos vehículos, contiguo a un Estudio y una Biblioteca que flanquean el ingreso principal. El núcleo social destaca por una Sala y Comedor integrados que conectan directamente con una Terraza exterior y una Piscina, rodeada de áreas de circulación. Hacia la zona posterior, se sitúa un Dormitorio Principal con vestidor y un Dormitorio de Hija, complementados por un área de servicios que incluye cocina, lavandería y depósito",
        "masVendidos": true,
        "level": 3,
        "style": "Minimalista",
        "cantidLaminas": 10,
        "driveId": "https://drive.google.com/file/d/1YECznXzIqfteJ3HrF2Lgz7xnBmfTfLaI/view?usp=drive_link",
        "id": 43
    },
    {
        "identity": "pl-0070",
        "name": "Edificación Mixta de 3 Niveles con Comercio en Planta Baja y Vivienda Multifamiliar",
        "category": "Departamento",
        "area": 120,
        "rooms": 4,
        "floors": 3,
        "front": 6,
        "depth": 20,
        "dimencion": "6x20",
        "price": 35,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778037174/bjko7lfl5og5su2onfaq.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778037197/vp1aiyturxqrfnfej9yk.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778037221/qpwjttfsec2jzvul29gp.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778037283/za1ccoqlm2qp1egbbvxt.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Emprendedores e Inversionistas",
        "description": "Proyecto de uso mixto que optimiza la rentabilidad del suelo. El primer piso es un local comercial de planta libre con depósito y servicios. Los pisos superiores albergan la vivienda: zona social y dormitorios en el segundo nivel, más áreas de descanso y estar en el tercero. Incluye azotea y especificaciones técnicas para una construcción precisa.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 6,
        "driveId": "https://drive.google.com/file/d/1moCmeQ-Q5wPUhYqszt5xoU8WA6-VRTvM/view?usp=drive_link",
        "id": 61
    },
    {
        "identity": "pl-0071",
        "name": "Residencia  Doble Nivel con Estacionamiento y Área Social Integrada",
        "category": "Casa",
        "area": 114,
        "rooms": 3,
        "floors": 2,
        "front": 6,
        "depth": 19,
        "dimencion": "6x19",
        "price": 35,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 45,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778037567/opjwev8vsxzma9a9p51m.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778037587/nratk2y3ppkgautqm3ox.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778037612/eadpgpwwohfuwutvw4gm.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778037865/crdbaibrcafd8jqf1tkg.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Familias que poseen dos vehículos, Terrenos angostos y profundos",
        "description": "Vivienda en lote de 6×19 m con zonificación eficiente. La planta baja integra sala, comedor, cocina con barra, dormitorio de servicio y garaje para dos autos. La planta alta alberga tres dormitorios con baños centrales. Incluye techo a dos aguas con pendientes que optimizan el drenaje pluvial.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 7,
        "driveId": "https://drive.google.com/file/d/1lCsA2KRr41I1wJQixzK6jatr1SBKj_mT/view?usp=drive_link",
        "id": 62
    },
    {
        "identity": "pl-0072",
        "name": "Residencial Multifamiliar de 4 Niveles con Salas Múltiples y Terraza Social",
        "category": "Casa",
        "area": 90,
        "rooms": 11,
        "floors": 1,
        "front": 6,
        "depth": 15,
        "dimencion": "6x15",
        "price": 45,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 60,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778120854/nub6nohvh3n147qqkfv0.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778120879/eaqfhdal6wgx8tnpjmtr.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778120906/fqgkoguavqcg5ezevbbn.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778120990/p9ku2f6qxhphc7ntns6s.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Familias extensas o multifamiliares",
        "description": "Este proyecto arquitectónico propone una vivienda de tres niveles y azotea funcional. El 1er piso incluye sala, comedor, cocina independiente y tres dormitorios. El 2do y 3er piso cuentan con hasta cuatro dormitorios y amplias salas múltiples. La azotea dispone de lavandería, tendal y una terraza panorámica para actividades sociales.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 7,
        "driveId": "https://drive.google.com/file/d/1x-T-kpy5TnZ8EsWk6CAKJaadLauSQcvB/view?usp=drive_link",
        "id": 63
    },
    {
        "identity": "pl-0073",
        "name": "Residencia Unifamiliar con Cuarto de Servicio, Balcón y Azotea Integral",
        "category": "Casa",
        "area": 78,
        "rooms": 5,
        "floors": 2,
        "front": 6,
        "depth": 13,
        "dimencion": "6x13",
        "price": 35,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 45,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778121257/fxedtega5nocdyjmfz3z.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778121270/jeh1wyo6hgdidf0e6hjz.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778121316/hlmdahyb3yozwlawhruw.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778121327/zmjeh1o6ew0vl3orbl8d.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Construcción en lotes típicos de 6m de frente",
        "description": "Este proyecto arquitectónico plantea una vivienda de dos niveles más azotea para un lote de 6.00 m de frente. El 1er nivel integra áreas sociales y zona de servicio con dormitorio y baño independiente. El 2do nivel alberga dormitorios amplios y un balcón frontal. La azotea ofrece un espacio versátil para servicios y recreación, ideal para la vida urbana moderna.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 6,
        "driveId": "https://drive.google.com/file/d/15nydQG3V2sz_sT-9bNbxpcN02ilhom4L/view?usp=drive_link",
        "id": 64
    },
    {
        "identity": "pl-0074",
        "name": "Residencia Unifamiliar de Tres Niveles con Estar Íntimo, Suite de Servicio y Terraza",
        "category": "Casa",
        "area": 90,
        "rooms": 7,
        "floors": 3,
        "front": 5,
        "depth": 16,
        "dimencion": "5x16",
        "price": 35,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 45,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778121604/m19yy63jrxgp9z3mhq3m.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778121629/dsyanyzc6ecysor3yt0h.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778121639/wnrnztrprlwomphrnid7.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778121650/kifkkh8luz8nbwvyrmzt.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Proyectos de inversión para alquiler",
        "description": "Este proyecto arquitectónico desarrolla una vivienda de cuatro niveles en un lote profundo. El 1° piso integra sala, comedor, cocina y un dormitorio con vista al patio. El 2° y 3° piso albergan dormitorios, estar familiar y halls de distribución. La azotea incluye dormitorio de servicio, área de tendal y una amplia terraza frontal para actividades al aire libre.",
        "masVendidos": false,
        "level": 3,
        "style": "",
        "cantidLaminas": 6,
        "driveId": "https://drive.google.com/file/d/1r6msJ3ly-5dpizFFFASvyS9j5FDvHi3L/view?usp=drive_link",
        "id": 65
    },
    {
        "identity": "pl-0076",
        "name": "Edificación Comercial - Salones",
        "category": "Comercial",
        "area": 120,
        "rooms": 0,
        "floors": 3,
        "front": 6,
        "depth": 20,
        "dimencion": "6x20",
        "price": 34,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 45,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778122463/ufkwlsameqr6xmkb2any.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778122473/govhwpje9cqpkujgsozu.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778122483/zyjnkkqfn0wxaafteuw2.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778122494/uvwf0mly5i1gm5vpdjii.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Para Salones Comerciales",
        "description": "Este proyecto arquitectónico propone un espacio comercial distribuido en cuatro niveles técnicos. El sótano incorpora cisterna y sistemas de extracción para servicios y almacenamiento. El 1° piso cuenta con recepción, sala de espera, área de exhibición y servicios higiénicos. El mezzanine ofrece una planta libre con balcón hacia la zona de exhibición, ideal para administración o ampliación comercial.",
        "masVendidos": false,
        "level": 2,
        "style": "Moderno",
        "cantidLaminas": 6,
        "driveId": "https://drive.google.com/file/d/1xfVVMcq4vG6gLKRpuL4TK2rYsChnhZm8/view?usp=drive_link",
        "id": 67
    },
    {
        "identity": "pl-0086",
        "name": "Vivienda con Local Comercial",
        "category": "Comercial",
        "area": 240,
        "rooms": 14,
        "floors": 3,
        "front": 8,
        "depth": 30,
        "dimencion": "8x30",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 0,
        "badge": "",
        "isOffer": false,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778704790/xlnsiy9wuukam7rb8sag.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778704804/zaypzzazvxrggssdshsp.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778704813/ascmgrsapmanaeel3n8v.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Familias pequeñas o parejas",
        "description": "Diseño arquitectónico optimizado para terrenos de fachada reducida que integra perfectamente el uso comercial y residencial. El primer nivel ofrece un amplio local comercial independiente, mientras que el segundo piso alberga una vivienda confortable con áreas sociales integradas y un dormitorio privado con tina.",
        "masVendidos": false,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 4,
        "driveId": "https://drive.google.com/file/d/1GJibthUIjSEyyYhZwpZ0_kHv41p41WAS/view?usp=drive_link",
        "id": 77
    },
    {
        "identity": "pl-0092",
        "name": "Residencia Unifamiliar Estilo Galería",
        "category": "Casa",
        "area": 210,
        "rooms": 6,
        "floors": 1,
        "front": 5,
        "depth": 22,
        "dimencion": "5x22",
        "price": 30,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 0,
        "badge": "",
        "isOffer": false,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778706673/nfl8g2lcveagflgjtbh7.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778706683/ykzhfq4m4ia5xd3cfsaf.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778706690/oqpjgagdesxcdrxkdnc3.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1778706698/g1gtkl6scpxz4kvpiqtx.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Propietarios de lotes urbanos estrechos",
        "description": "Diseño arquitectónico moderno que optimiza terrenos profundos y estrechos. La planta baja integra un garaje frontal y áreas sociales fluidas que conectan con un patio posterior, mientras que el segundo nivel ofrece tres dormitorios espaciosos y una sala familiar privada.",
        "masVendidos": false,
        "level": 3,
        "style": "Clásico",
        "cantidLaminas": 9,
        "driveId": "https://drive.google.com/file/d/1kRnA6j1XzZbtGppfJvw0dvUkqf4oIVPv/view?usp=drive_link",
        "id": 83
    },
    {
        "identity": "pl-0029",
        "name": "Vivienda Unifamiliar Integral: Espacio, Confort y Terraza",
        "category": "Casa",
        "area": 90,
        "rooms": 6,
        "floors": 3,
        "front": 6,
        "depth": 15,
        "dimencion": "6x15",
        "price": 30,
        "type": "plano",
        "packageType": "Intermedio",
        "originalPrice": 40,
        "badge": "OFERTA",
        "isOffer": true,
        "electric": true,
        "sanitary": true,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras",
            "Inst. Eléctricas",
            "Inst. Sanitarias",
            "Cortes y Secciones"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777917967/jzfffuvumnmlc7zfu5tv.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777917974/byxyi02cfj4e2putmz7c.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777917985/lmarjttuyuvwzptvxicy.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777917999/n3jpo0bdxdkidvlt7z3n.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777918013/uwq4kqlbcadbwrgwaipq.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777918034/ia8slwutzjdjngzseuia.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Separación de Ambientes, Dormitorios Espaciosos",
        "description": "Propuesta de vivienda unifamiliar que distribuye de manera eficiente el programa residencial en tres plantas completas y una azotea funcional. El primer piso recibe al usuario con una cochera privada, un hall de ingreso, una sala espaciosa, comedor, cocina y un área de jardín posterior que asegura ventilación cruzada. El segundo y tercer nivel se consolidan como la zona privada, albergando dormitorios con balcones frontales y baños distribuidos estratégicamente para servir a cada piso. Finalmente, la azotea ofrece un área de lavandería, tendal y una amplia terraza diseñada para el esparcimiento social. El núcleo de escaleras lateral conecta todos los niveles de forma fluida, permitiendo un aprovechamiento máximo de la iluminación natural.",
        "masVendidos": true,
        "level": 3,
        "style": "Moderno",
        "cantidLaminas": 7,
        "driveId": "https://drive.google.com/file/d/1Ka5FsmkEpcRrXm7quDjFH2STKWmxr51B/view?usp=drive_link",
        "id": 20
    },
    {
        "identity": "pl-0049",
        "name": "Vivienda Multifamiliar",
        "category": "Casa",
        "area": 112,
        "rooms": 6,
        "floors": 3,
        "front": 7,
        "depth": 16,
        "dimencion": "7x16",
        "price": 10,
        "type": "plano",
        "packageType": "basico",
        "originalPrice": 0,
        "badge": "",
        "isOffer": false,
        "electric": false,
        "sanitary": false,
        "formats": [
            "PDF",
            "DWG"
        ],
        "includes": [
            "Arquitectura",
            "Estructuras"
        ],
        "images": [
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777939294/dy0mxmcknw5zfhqw2oxe.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777939305/yshrqwlorwgmszds8wda.jpg",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777939314/dx1bqk2p1ehmvlownafp.png",
            "https://res.cloudinary.com/df39lyfsp/image/upload/v1777906945/iggbb1tlfwalrva2hl8o.jpg"
        ],
        "planType": "Estándar",
        "bonus": "",
        "idealFor": "Distribución de Tres Dormitorios, Áreas Sociales Fluídas",
        "description": "El proyecto se desarrolla en cinco niveles más azotea, segmentando las funciones por planta para asegurar la privacidad y eficiencia operativa. El 1er Piso combina el acceso principal con una Tienda hacia la fachada y un departamento posterior de tres dormitorios. El 2do Piso y la planta típica del 3er al 5to Piso presentan departamentos completos de tres dormitorios con áreas sociales integradas. El edificio corona con una Azotea destinada a servicios comunes como la Lavandería.",
        "masVendidos": false,
        "level": 3,
        "style": "Minimalista",
        "cantidLaminas": 3,
        "driveId": "https://drive.google.com/file/d/1yJrAZIRCVET-0NQTEPU-K1_YAPVOdy50/view?usp=drive_link",
        "id": 40
    },
];